
import type { FeatureFlags } from 'lib-customizations/types'

import type { Env } from './env'
import { env } from './env'

type Features = {
  default: FeatureFlags
} & Record<Env, FeatureFlags>


const features: Features = {
  default: {
    environmentLabel: 'Lokaali',
    citizenShiftCareAbsence: true,
    assistanceActionOther: true,
    daycareApplication: {
      dailyTimes: true,
      serviceNeedOption: true,
    },
    preschoolApplication: {
      connectedDaycarePreferredStartDate: true,
      serviceNeedOption: true,
    },
    decisionDraftMultipleUnits: true,
    preschool: true,
    preparatory: false,
    urgencyAttachments: true,
    financeDecisionHandlerSelect: true,
    feeDecisionPreschoolClubFilter: true,
    placementGuarantee: false,
    voucherUnitPayments: true,
    voucherValueSeparation: true,
    extendedPreschoolTerm: true,
    citizenAttendanceSummary: true,
    intermittentShiftCare: true,
    noAbsenceType: true,
    discussionReservations: true,
    jamixIntegration: false,
    nekkuIntegration: false,
    forceUnpublishDocumentTemplate: false,
    invoiceDisplayAccountNumber: true,
    serviceApplications: true,
    multiSelectDeparture: true,
    archiveIntegration: {
      childDocuments: false
    },
    aromiIntegration: true,
    citizenChildDocumentTypes: true,
    decisionChildDocumentTypes: true,
    showCitizenApplicationPreschoolTerms: true,
    missingQuestionnaireAnswerMarkerEnabled: false,
    absenceApplications: true,
    showMetadataToCitizen: true,
    placementDesktop: true,
  },
  staging: {
    environmentLabel: 'Staging',
    citizenShiftCareAbsence: true,
    assistanceActionOther: false,
    daycareApplication: {
      dailyTimes: true,
      serviceNeedOption: true,
    },
    preschoolApplication: {
      connectedDaycarePreferredStartDate: false,
      serviceNeedOption: false,
    },
    decisionDraftMultipleUnits: false,
    preschool: true,
    preparatory: false,
    urgencyAttachments: false,
    financeDecisionHandlerSelect: false,
    feeDecisionPreschoolClubFilter: false,
    placementGuarantee: true,
    voucherUnitPayments: false,
    voucherValueSeparation: true,
    extendedPreschoolTerm: true,
    citizenAttendanceSummary: true,
    intermittentShiftCare: false,
    noAbsenceType: true,
    discussionReservations: true,
    jamixIntegration: false,
    nekkuIntegration: false,
    forceUnpublishDocumentTemplate: false,
    invoiceDisplayAccountNumber: true,
    serviceApplications: true,
    multiSelectDeparture: true,
    archiveIntegration: {
      childDocuments: false
    },
    aromiIntegration: true,
    citizenChildDocumentTypes: true,
    decisionChildDocumentTypes: true,
    showCitizenApplicationPreschoolTerms: true,
    missingQuestionnaireAnswerMarkerEnabled: false,
    absenceApplications: true,
    showMetadataToCitizen: true,
    placementDesktop: true,
  },
  prod: {
    environmentLabel: null,
    citizenShiftCareAbsence: true,
    assistanceActionOther: false,
    daycareApplication: {
      dailyTimes: true,
      serviceNeedOption: true,
    },
    preschoolApplication: {
      connectedDaycarePreferredStartDate: false,
      serviceNeedOption: false,
    },
    decisionDraftMultipleUnits: false,
    preschool: true,
    preparatory: false,
    urgencyAttachments: false,
    financeDecisionHandlerSelect: false,
    feeDecisionPreschoolClubFilter: false,
    placementGuarantee: true,
    voucherUnitPayments: false,
    voucherValueSeparation: true,
    extendedPreschoolTerm: true,
    citizenAttendanceSummary: true,
    intermittentShiftCare: false,
    noAbsenceType: true,
    discussionReservations: true,
    jamixIntegration: false,
    nekkuIntegration: false,
    forceUnpublishDocumentTemplate: false,
    invoiceDisplayAccountNumber: false,
    serviceApplications: true,
    multiSelectDeparture: true,
    archiveIntegration: {
      childDocuments: false
    },
    aromiIntegration: false,
    citizenChildDocumentTypes: true,
    decisionChildDocumentTypes: true,
    showCitizenApplicationPreschoolTerms: true,
    missingQuestionnaireAnswerMarkerEnabled: true,
    absenceApplications: false,
    showMetadataToCitizen: false,
    placementDesktop: true,
  },
}

const featureFlags = features[env()]

export default featureFlags
